module.exports = __webpack_public_path__ + "static/img/011.d221b0a0.png";